let url = "http://uat.zhaoshang800.com";
if (location.host === "test.pmis.zhaoshang800.com") {
  url = "http://test.zhaoshang800.com";
}
if (location.host === "dev.pmis.zhaoshang800.com") {
  url = "http://dev.api.zhaoshang800.com";
}
if (location.host === "uat.pmis.zhaoshang800.com") {
  url = "http://uat.zhaoshang800.com";
}
if (location.host === "app.zhaoshang800.com") {
  url = "https://api.zhaoshang800.com";
}

var Config = {
  url,
};

export default Config;



// WEBPACK FOOTER //
// ./src/pages/message-verification/config.js